<template src='./FormularioDialogoSecciones.html'>
    
</template>
<script>
import metodos_comunes from "../../js/metodos_comunes";
import {cargarDocumentoAsistida} from "../../apiService/request/Calendario"
export default {
    data() {
        return {
            dialog: false,
            step: 1,
            reglasObligatorio: [v => !!v || "Campo obligatorio"],
            archivoSubido:[],
            files:[],
            mensajeRespuestaEnpoint:[],
            cantidadVariables: 1,
        }
    },
    props:{
        nombreBoton: {
            type: String,
        },
        esquemaCrearHorariosExcel:{
            type: Object,
        }
    },
    methods:{
        posicionSeleccionLista(formulario, index) {
        // console.log('formulario:', formulario)
        
        formulario[index].seleccion = {
            lista: formulario[index].lista,
            valor: formulario[index].valor
        };
        this.variablesEventoSeleccionado = formulario;
        // this.$store.dispatch("setVariablesFormularios", formulario);
        this.construccionOpcionesLista(index);
        this.validarVariablesLlenas(index);
        },
        validarVariablesLlenas(index) {
                console.log('this.cantidadVariables');
            if(this.esquemaCrearHorariosExcel.variables[index].valor) {
                this.cantidadVariables += 1;
                console.log('this.cantidadVariables2',this.cantidadVariables);
            }else {
                this.cantidadVariables -= 1;
            }
        },
        construccionOpcionesLista(index) {
        const condiciones = this.variablesEventoSeleccionado[index].seleccion;
        const arrayVariables = this.variablesEventoSeleccionado;
        const self = this;
        arrayVariables.map((elemento, index1) => {
            if (elemento.indexPadre == index) {
            elemento.valor = null;
            self.posicionSeleccionLista(arrayVariables, index1);
            elemento.lista_seleccionada = elemento.opciones_lista.filter(x =>
                x.condiciones.some(
                e =>
                    metodos_comunes.reemplazarCaracteresEspeciales(e.lista) ===
                    metodos_comunes.reemplazarCaracteresEspeciales(
                        condiciones.lista
                    ) &&
                    metodos_comunes.reemplazarCaracteresEspeciales(e.valor) ===
                    metodos_comunes.reemplazarCaracteresEspeciales(
                        condiciones.valor
                    )
                )
            );
            elemento.habilitado = self.habilitarSelect(
                elemento.lista_seleccionada
            );
            }
        });
        this.variablesEventoSeleccionado = arrayVariables;
        this.renderizar += 1;
        },
        habilitarSelect(lista_seleccionada) {
            if (lista_seleccionada.length > 0) {
                return true;
            }
            return false;
        },
        // seleccionarArchivo(index) {
        //     console.log('file:', this.files);
        //     this.esquemaCrearHorariosExcel.variables[index].valor= this.files
        // },
        async actualizarFormularioCreacionHorario(){
            this.$store.dispatch("setCargando", true);
            let formData = new FormData();
            formData.append("fileCSV", this.files);
            formData.append("responsable", this.esquemaCrearHorariosExcel.variables[2].valor);
            formData.append("sede", this.esquemaCrearHorariosExcel.variables[3].valor);
            formData.append("creado_por" , this.$store.state.provider_email);
            console.log('file2:', this.files,formData);
            try{
                this.mensajeRespuestaEnpoint=await cargarDocumentoAsistida( this.files,formData)
                
            }finally{
                this.$store.dispatch("setCargando", false);
                const dialogoModal = {
                    status: this.mensajeRespuestaEnpoint.data.status,
                    dialogo: false,
                    data: {
                        message: this.mensajeRespuestaEnpoint.data.message
                    }
                };
                if (dialogoModal.status == 200) {
                    this.dialog = false
                    this.files=[]
                    this.step=1
                    this.$emit('resetearVariables');
                }
                this.$store.dispatch("cambiarEstadoModal", true);
                this.$store.dispatch("cambiarMensajeModal", dialogoModal);
                
            }
        }
        
    }
}
</script>
<style lang="scss" src='./FormularioDialogoSecciones.scss' scoped>

</style>


// WEBPACK FOOTER //
// src/components/FormularioDialogoSecciones/FormularioDialogoSecciones.vue